// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalRequestForm-additionalRequestTimerContainer-WOiA1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 18px;
    grid-gap: 18px;
}

.AdditionalRequestForm-additionalRequestTimerInfo-flmjz {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 6px;
    grid-gap: 6px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.AdditionalRequestForm-additionRequestBookingIdInfoIdBox-YL8_R {
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    padding: 3px 12px;
    background: var(--opt-bg);
    border-radius: var(--radius-5);
    color: var(--common-primary-black-foreground);
    text-align: center;
}

.AdditionalRequestForm-additionalRequestTimerClock-InrC_ {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.AdditionalRequestForm-additionalRequestTimerCount-uVXs4 {
    font-size: 24px;
    font-weight: 700;
    line-height: 34px;
    color: var(--primary-foreground);
}

.AdditionalRequestForm-additionalRequestTimerSecText-T8uUf {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: var(--primary-foreground);
}

.AdditionalRequestForm-additionalRequestHeadingSpace10-JDZsQ {
    margin-bottom: 10px;
}

@media (max-width: 575px) {
    .AdditionalRequestForm-additionalRequestTimerContainer-WOiA1 {
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
            -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        row-gap: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AdditionalRequestForm/AdditionalRequestForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA8B;QAA9B,8BAA8B;YAA9B,kCAA8B;gBAA9B,8BAA8B;QAC9B,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,aAAa;IACjB;AACJ","sourcesContent":[".additionalRequestTimerContainer {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.additionalRequestTimerInfo {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    flex-grow: 1;\n}\n\n.additionRequestBookingIdInfoIdBox {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 700;\n    padding: 3px 12px;\n    background: var(--opt-bg);\n    border-radius: var(--radius-5);\n    color: var(--common-primary-black-foreground);\n    text-align: center;\n}\n\n.additionalRequestTimerClock {\n    flex-shrink: 0;\n}\n\n.additionalRequestTimerCount {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 34px;\n    color: var(--primary-foreground);\n}\n\n.additionalRequestTimerSecText {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    color: var(--primary-foreground);\n}\n\n.additionalRequestHeadingSpace10 {\n    margin-bottom: 10px;\n}\n\n@media (max-width: 575px) {\n    .additionalRequestTimerContainer {\n        flex-direction: column-reverse;\n        align-items: flex-start;\n        row-gap: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalRequestTimerContainer": `AdditionalRequestForm-additionalRequestTimerContainer-WOiA1`,
	"additionalRequestTimerInfo": `AdditionalRequestForm-additionalRequestTimerInfo-flmjz`,
	"additionRequestBookingIdInfoIdBox": `AdditionalRequestForm-additionRequestBookingIdInfoIdBox-YL8_R`,
	"additionalRequestTimerClock": `AdditionalRequestForm-additionalRequestTimerClock-InrC_`,
	"additionalRequestTimerCount": `AdditionalRequestForm-additionalRequestTimerCount-uVXs4`,
	"additionalRequestTimerSecText": `AdditionalRequestForm-additionalRequestTimerSecText-T8uUf`,
	"additionalRequestHeadingSpace10": `AdditionalRequestForm-additionalRequestHeadingSpace10-JDZsQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
